import useAsyncData from "../../../../../hooks/use-async-data";
import orderService from "../../../order.service";
import OrderCargoOrderAbandonedList from "./order-cargo-order-abandoned-list";
import OrderCargoOrderAbandonedListParams from "./order-cargo-order-abandoned-list-params";

const useOrderCargoOrderAbandonedList = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<OrderCargoOrderAbandonedList>({
      data: [],
      totalCount: 0,
    });

  const load = async (
    params: OrderCargoOrderAbandonedListParams,
    signal: AbortSignal,
  ) => {
    setIsError(false);
    setIsLoading(true);

    try {
      const cargoOrderAbandonedList = await orderService.getAbandonedList(
        params,
        signal,
      );

      setData(cargoOrderAbandonedList);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useOrderCargoOrderAbandonedList;
